import React from "react";

const StandardBike = ({ title, ...props }) => (
  <svg version="1.1" viewBox="0 0 32 32" height="100%" width="100%" {...props}>
    <g>
      <path d="M6.9,15.4c-3.8,0-6.9,3.1-6.9,6.9c0,3.8,3.1,6.9,6.9,7c3.8,0,6.9-3.1,6.9-7C13.9,18.6,10.8,15.5,6.9,15.4z M10.7,26.1 c-0.9,1-2.3,1.6-3.7,1.6c-1.4,0-2.8-0.6-3.7-1.6c-0.9-0.9-1.5-2.3-1.5-3.7c0-1.4,0.6-2.8,1.5-3.7c1-1,2.3-1.5,3.7-1.5 c1.4,0,2.8,0.6,3.7,1.5c1,0.9,1.5,2.3,1.5,3.7C12.2,23.8,11.6,25.2,10.7,26.1z" />
      <path d="M19.2,7.7c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5C16.7,6.6,17.8,7.7,19.2,7.7z" />
      <path d="M23.9,13.9c1.5,0,1.5-2-0.1-2h-4l-2.8-4.6c-0.6-0.8-2.3-0.9-3-0.1l-4.9,4.9C8,13.3,8.7,15,10,15.4l4.5,2.8v4.6 c0,1,0.8,1.6,1.5,1.6c0.7,0,1.5-0.5,1.5-1.6V17c0-0.5-0.1-1.2-0.5-1.3l-3-1.9l2.5-2.6l1.5,2c0.3,0.6,0.9,0.8,1.5,0.8H23.9z" />
      <g>
        <path d="M25.1,15.3c-3.8,0-6.9,3.1-6.9,6.9c0,3.8,3.1,6.9,6.9,6.9c3.8,0,6.9-3.1,6.9-6.9C32,18.5,28.9,15.3,25.1,15.3z M28.8,26 c-0.9,0.9-2.3,1.5-3.7,1.5c-1.4,0-2.8-0.6-3.7-1.5c-0.9-1-1.5-2.3-1.5-3.7c0-1.5,0.6-2.8,1.5-3.7c1-1,2.3-1.5,3.7-1.5 c1.5,0,2.8,0.6,3.7,1.5c1,1,1.5,2.3,1.5,3.7C30.3,23.7,29.7,25,28.8,26z" />
      </g>
    </g>
  </svg>
);

export default StandardBike;
